if (!customElements.get('size-chart')) {

    class SizeChart extends HTMLElement {
        constructor() {
            super();
            
            this.drawer       = this.querySelector('.size-chart');
            this.closeButton  = this.drawer.querySelector('.drawer__close');
            // this.trigger      = document.querySelector('.size-chart-button');

            this.listeners();

        }

        open(event) {
            const trigger = event.target.closest('.size-chart-button');
            const selectedSizeInput = trigger
                .closest('.product-form__input')
                ?.querySelector('input[type="radio"]:checked');
            const triggerVariant = selectedSizeInput?.value
                || trigger.getAttribute('data-variant');
            const activeCells = this.drawer.querySelectorAll(`td[data-variant="${triggerVariant}"]`);

            activeCells.forEach(cell => cell.classList.add('active'));

            document.body.classList.add('hidden');
            this.drawer.classList.add('active');
            this.closeButton.addEventListener('click', this.close.bind(this));

        }

        close() {
            document.body.classList.remove('hidden');
            this.drawer.classList.remove('active');
            this.closeButton.removeEventListener('click', this.close.bind(this));
            this.drawer.querySelectorAll('td.active').forEach(cell => cell.classList.remove('active'));
        }

        listeners() {
            document.addEventListener('click', (event) => {
                if (event.target.closest('.size-chart-button')) {
                    this.open(event);
                }
            });

            if (this.drawer) {
                this.drawer.addEventListener('click', (event) => {
                    if (!event.target.closest('.product-size-chart-drawer')) {
                        this.close();
                    }
                });
            }
        }

    }
        
    customElements.define('size-chart', SizeChart);
}
  